export default class {
    _id;
    _inn;
    _name;
    _address;
    _accountNumber;
    _mfo;
    _phoneNumber;
    _createdOn;
    _contractSignerGlobalUnit;
    _contractSignerGlobalUnitId;
    _sentMailsCount
    _createdMailsCount
    _isActive;
    _unitsCount;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }


    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get address() {
        return this._address
    }

    set address(value) {
        this._address = value
    }

    get inn() {
        return this._inn
    }

    set inn(value) {
        this._inn = value
    }

    get createdOn() {
        return this._createdOn
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get contractNumber() {
        return this._contractNumber
    }

    set contractNumber(value) {
        this._contractNumber = value
    }

    get contractDate() {
        return this._contractDate
    }

    set contractDate(value) {
        this._contractDate = value
    }

    get isActive() {
        return this._isActive
    }

    set isActive(value) {
        this._isActive = value
    }

    get accountNumber() {
        return this._accountNumber;
    }

    set accountNumber(value) {
        this._accountNumber = value;
    }

    get mfo() {
        return this._mfo;
    }

    set mfo(value) {
        this._mfo = value;
    }

    get phoneNumber() {
        return this._phoneNumber;
    }

    set phoneNumber(value) {
        this._phoneNumber = value;
    }


    get createdMailsCount() {
        return this._createdMailsCount;
    }

    set createdMailsCount(value) {
        this._createdMailsCount = value;
    }

    get sentMailsCount() {
        return this._sentMailsCount;
    }

    set sentMailsCount(value) {
        this._sentMailsCount = value;
    }

    get unitsCount() {
        return this._unitsCount;
    }

    set unitsCount(value) {
        this._unitsCount = value;
    }

    get contractSignerGlobalUnit() {
        return this._contractSignerGlobalUnit;
    }

    set contractSignerGlobalUnit(value) {
        this._contractSignerGlobalUnit = value;
    }

    get contractSignerGlobalUnitId() {
        return this._contractSignerGlobalUnitId
    }

    set contractSignerGlobalUnitId(value) {
        return this._contractSignerGlobalUnitId = value
    }
}
